export enum ZIndices {
  OrderInfoOverlay = 1,
  Carousel = 2,
  LocaId = 3,
  PieMenu = 4,
  ConfigOverlay = 8,
  SimpleTableProgress = 50,
  QuickOverlay = 900,
  Overlay = 1000, //1500, // ComboBox Overlay => QuickOverlay https://plaspack.atlassian.net/browse/APP-15016
  RightOverlay = 1100,
  InfoOverlay = 1200,
  MainMenu = 3000,
  Spinner = 4000,
  ErrorMessage = 5000,
  NotificationHub = 100000,
  ErrorBoundary = 200000,
  TouchPointVisu = 1000000,
}